import { formatBatchLabel } from '@/utils/batchIdentity';

export function getAvailableParticipantOptions({ batches, currentBatch, enrolledParticipants, availableParticipants, isDraftParticipant }) {
  const otherBatches = batches.filter(batch => batch.training_event_id !== currentBatch.training_event_id);
  const draftCandidates = otherBatches.flatMap(batch =>
    (batch.company_participants || []).filter(isDraftParticipant)
  );
  const candidates = [...draftCandidates, ...availableParticipants];
  const seen = new Set();

  return candidates
    .filter(participant => {
      if (!participant.nik && participant.tna_id == null) return false;
      const key = participant.nik ? `nik:${participant.nik}` : `tna:${participant.tna_id}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .filter(participant => !enrolledParticipants.some(item => item.nik === participant.nik))
    .filter(participant => !batches.some(batch =>
      (batch.company_participants || []).some(item =>
        item.nik === participant.nik && !isDraftParticipant(item)
      )
    ))
    .map(participant => {
      const sourceBatch = otherBatches.find(batch =>
        (batch.company_participants || []).some(item =>
          item.nik === participant.nik && isDraftParticipant(item)
        )
      );
      return {
        label: `${participant.fullname || participant.full_name || '-'} (${participant.nik})${sourceBatch ? ` · Draft di ${formatBatchLabel(sourceBatch)}` : ''}`,
        value: participant
      };
    });
}
